import { IProductMap } from "../type/IProductMap";
import { IShoppingCartItems, IShoppingCartStringItems } from "../type/IShoppingCartItems";
import { getProductsByIds } from "./getProductsByIds";

export const shoppingCartGetCartItems = (shoppingCartString: string, productMap: IProductMap): IShoppingCartItems[] => {
  if (!shoppingCartString) return [];
  const shoppingCartStringItems: IShoppingCartStringItems = JSON.parse(shoppingCartString);
  const products = getProductsByIds(Object.keys(shoppingCartStringItems), productMap);
  return Object.entries<number>(shoppingCartStringItems).map((entry, index) => ({ id: entry[0], qty: entry[1], product: products[index] }));
}